/**
 * Rack edit payload — fields that RackConfigUpdate accepts (no `name`).
 * Run: node --experimental-strip-types frontend/src/utils/rackEdit.logic.test.mjs
 */

/** 1U height in meters (standard rack unit). */
export const U_HEIGHT_M = 0.04445

export type RackEditForm = {
  type: string
  heightU: number | null
  isBlocked: boolean
  tenant?: string | null
  cascadeTenant?: boolean
  maxWeightKg?: number | null
  maxPowerW?: number | null
  widthM?: number | null
  depthM?: number | null
}

/** Body for PUT /api/datacenters/racks/{id}. Independent of RackEditModal JSX. */
export function rackUpdatePayload(form: RackEditForm, original?: RackEditForm): Record<string, unknown> {
  const body: Record<string, unknown> = {}
  const fields = { type: 'type', heightU: 'u_slots', isBlocked: 'is_blocked', tenant: 'tenant',
    maxWeightKg: 'max_weight_kg', maxPowerW: 'max_power_w', widthM: 'width_m', depthM: 'depth_m' } as const
  for (const [key, field] of Object.entries(fields)) {
    const value = form[key as keyof typeof fields]
    if (value === undefined || (typeof value === 'number' && !Number.isFinite(value))) continue
    if (!original || value !== original[key as keyof typeof fields]) body[field] = value
  }
  if (form.cascadeTenant && form.tenant) {
    body.tenant = form.tenant
    body.cascade_tenant = true
  }
  return body
}

export function rackDisplayTitle(rack: { label?: string; id?: number; name?: string } | null): string {
  if (!rack) return 'Стойка'
  if (rack.label) return rack.label
  if (rack.id != null) return `Стойка #${rack.id}`
  return 'Стойка'
}
